<script>
import AdminLayout from '@layouts/admin-main'

export default {
  page: {
    title: 'Admin::Index',
    meta: [{ name: 'description', content: 'Admin::Index' }],
  },
  components: { AdminLayout },
}
</script>

<template>
  <AdminLayout>
    Admin/index
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/layout.scss';
@import '@src/design/font.scss';
@import '@src/design/pagination.scss';
</style>
